import Cookies from 'cookies-js';
import MediaQueries, {breakpoint} from '~/constants/MediaQueries';
import {
  designParamsPresent,
  getInternalUserParam,
  productParamsPresent
} from '~/utils/url';

export const INTERNAL_USER_FLAG = 'internal';

export function isInternal() {
  const internalUserParam = getInternalUserParam();
  return internalUserParam || Cookies.get(INTERNAL_USER_FLAG) === 'true';
}

export function productEligible() {
  return productParamsPresent();
}

export function isEligibleForStreamlinedMobile() {
  return (
    breakpoint(MediaQueries.mediumAndBelow) &&
    productParamsPresent() &&
    !designParamsPresent()
  );
}

export function getZipCodeCookie() {
  const address = Cookies.get('address');
  if (!address) return;
  const addressCookie = JSON.parse(address);
  return String(addressCookie.postal_code).replace('+', ' ');
}
